<p-autoComplete
  [(ngModel)]="selection"
  (ngModelChange)="onSelectionChange($event)"
  [suggestions]="suggestions"
  (completeMethod)="filter($event.query)"
  [field]="optionLabel"
  [dataKey]="optionValue || ''"
  [dropdown]="true"
  [forceSelection]="true"
  [multiple]="multiple"
  [unique]="true"
  [completeOnFocus]="true"
  [showEmptyMessage]="true"
  [minLength]="0"
  [delay]="0"
  [placeholder]="placeholder"
  [disabled]="disabled"
  [appendTo]="appendTo"
  [scrollHeight]="scrollHeight"
  [inputId]="inputId"
  (onBlur)="onTouched()"
  (mousedown)="onFieldMouseDown($event)"
  styleClass="acan-select"
  [class.acan-select--multiple]="multiple"
  panelStyleClass="acan-select-panel">
  <ng-template let-option pTemplate="item">
    <ng-container *ngIf="itemTemplate; else plainItem">
      <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: option }"></ng-container>
    </ng-container>
    <ng-template #plainItem>
      <span class="acan-select__label">{{ labelOf(option) }}</span>
    </ng-template>
  </ng-template>

  <ng-template pTemplate="empty">
    <button
      *ngIf="allowAdd; else noResults"
      type="button"
      class="acan-select__add"
      (mousedown)="$event.preventDefault()"
      (click)="emitAdd()">
      <i class="pi pi-plus"></i>
      <span *ngIf="lastQuery">Add "{{ lastQuery }}"</span>
      <span *ngIf="!lastQuery">{{ addNewLabel }}</span>
    </button>
    <ng-template #noResults>
      <span class="acan-select__empty">No results</span>
    </ng-template>
  </ng-template>

  <ng-template pTemplate="footer">
    <button
      *ngIf="allowAdd && suggestions.length"
      type="button"
      class="acan-select__add acan-select__add--footer"
      (mousedown)="$event.preventDefault()"
      (click)="emitAdd()">
      <i class="pi pi-plus"></i> {{ addNewLabel }}
    </button>
  </ng-template>
</p-autoComplete>
